exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".selector-container{margin-right:10px;margin-bottom:6px;display:inline-block}.selector-container label{font-weight:700;font-size:12px;display:block}.selector-container .selector{display:inline-table;width:100%}.selector-container:last-child{margin-right:0}.Select--multi .Select-value{margin-top:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/Modules/Selector/Selector.less
// module id = 1604
// module chunks = 0